(function () {
  if (window.__weBisLock) return;
  window.__weBisLock = true;

  var OPEN = "nbis-open";
  var html = document.documentElement;

  function findOverlay() {
    return document.querySelector(".NBIS-Modal__overlay");
  }

  function canPopover(el) {
    return !!(el && typeof el.showPopover === "function");
  }

  function isPopoverOpen(el) {
    return el.matches && el.matches(":popover-open");
  }

  function sync() {
    var el = findOverlay();
    var open = !!(el && el.classList.contains("NBIS-Modal__overlay_visible"));
    html.classList.toggle(OPEN, open);
    if (!el || !canPopover(el)) return;

    if (open) {
      if (el.getAttribute("popover") !== "manual") {
        el.setAttribute("popover", "manual");
      }
      if (!isPopoverOpen(el)) {
        try {
          el.showPopover();
        } catch (error) {
          /* already open or not connected */
        }
      }
      return;
    }

    if (isPopoverOpen(el)) {
      try {
        el.hidePopover();
      } catch (error) {
        /* already closed */
      }
    }
  }

  var observer = new MutationObserver(sync);

  function start() {
    if (!document.body) return;
    observer.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });
    sync();
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener("DOMContentLoaded", start);
  }

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    var close = document.querySelector(".NBIS-Modal__overlay_visible a.NBIS-Modal__close");
    if (close) close.click();
  });
})();
